<template>
  <div class="od-container" id="column">
    <div class="contents">
      <h3>오늘하루 컬럼</h3>

      <ul class="bo_list motion" v-if="columnList !== null">
        <li v-for="(item) in columnList" :key="item.id">
          <div class="ibox" @click="goView(item.id)">
            <div class="img">
              <span>
              <img v-if="item.img !== null && item.img !== ''" v-lazy="`${publicPath}upload/column/${item.img}`" width="580" height="335"
                   alt="" />
                <svg v-else class="bd-placeholder-img figure-img img-fluid" width="100%" height="335"
                     xmlns="http://www.w3.org/2000/svg"
                     preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 400x300">
                  <title>{{item.title}}r</title>
                  <rect width="100%" height="100%" fill="#868e96"></rect>
                </svg>
            </span>
            </div>
            <div class="info">
              <p class="subject">{{item.title | normalize}}</p>
              <p class="conts">
                {{item.content | plainText}}
              </p>
              <p class="date">{{item.createAt | moment}}</p>
            </div>
          </div>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MediaColumn',
  computed: {
    ...mapGetters(['columnList']),
  },
  mounted() {
    this.$store.dispatch('getColumnList');
  },
  methods: {
    goView(id) {
      this.$router.push({ name: 'mediaColumnView', params: { id } });
    },
  },
};
</script>

<style scoped>

</style>
